// Ввод промокода (ТЗ раздел 3.3, экран 8) — до 2026-08-20 жил на экране "Ещё" отдельным блоком,
// перенесён сюда по запросу пользователя: логически он ближе к покупке ("Тарифы" → "Купить"), чем
// к отмене/истории платежей. Сама логика НЕ менялась, только место — переиспользуемый компонент,
// подключается на CheckoutScreen.tsx под кнопкой "Оплатить", один и тот же для всех тарифов (сам
// промокод не привязан к конкретному plan.id, см. app/api/routes/miniapp/promo.py).
//
// Единственный сейчас рабочий тип промокода (DiscountType.FREE_PERIOD) активирует пробную
// подписку напрямую, минуя оплату. При успехе обновляем общий subscriptionStore — экран "Моя
// подписка" сразу увидит новую подписку без повторного похода на сервер.
//
// Успех — просто "Промокод активирован!" (по замечанию пользователя 2026-08-20), БЕЗ списка
// ссылок на установку: скачать антивирус можно на экране "Моя подписка" у самого устройства
// (кнопка "Скачать"), дублировать тот же список сразу после активации — лишнее. Backend
// по-прежнему возвращает `install_packages` в ответе (не менялся), просто здесь не используем.
import { useState, type FormEvent } from "react";
import { useTranslation } from "react-i18next";

import { ApiError, redeemPromo } from "../api/client";
import { useSubscriptionStore } from "../store/subscriptionStore";

export function PromoCodeSection() {
  const { t } = useTranslation();
  const { setSubscription } = useSubscriptionStore();
  const [code, setCode] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmed = code.trim();
    if (!trimmed) return;
    setSubmitting(true);
    setError(null);
    setSuccess(false);
    redeemPromo(trimmed)
      .then(({ subscription }) => {
        setSubscription(subscription);
        setSuccess(true);
        setCode("");
      })
      .catch((err: unknown) => setError(err instanceof ApiError ? err.message : String(err)))
      .finally(() => setSubmitting(false));
  };

  return (
    <section className="promo-code-section">
      <h2>{t("promo_title")}</h2>
      {error && <p role="alert">{error}</p>}
      {success && <p>{t("promo_success")}</p>}
      <form onSubmit={handleSubmit}>
        <input
          value={code}
          onChange={(event) => setCode(event.target.value)}
          placeholder={t("promo_code_placeholder")}
        />
        <button type="submit" disabled={submitting || !code.trim()}>
          {submitting ? t("loading") : t("promo_submit")}
        </button>
      </form>
    </section>
  );
}
